import React from "react";
import PropTypes from "prop-types";
import { SidePanel, SidePanelContent } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import HistoryView from "./components/history-view/HistoryView";

export default function CommitmentHistory({ open, onClose, commitmentId }) {
	return (
		<SidePanel open={open} position="right" size={40} onClose={onClose}>
			<SidePanelContent title={translate("commitment-tracking.details.tab.history")} onClose={onClose}>
				<HistoryView commitmentId={commitmentId} />
			</SidePanelContent>
		</SidePanel>
	);
}

CommitmentHistory.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	commitmentId: PropTypes.number,
};

CommitmentHistory.defaultProps = {
	commitmentId: null,
};
